import menu, { PATH_HOME, hiddenForEmployee } from "@/config/menu";
import useAuth from "@/hooks/useAuth";
import { FaChevronLeft, FaChevronRight, FaSignOutAlt } from "react-icons/fa";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { useCallback } from "react";
import { useMenu } from "@/hooks/useMenu";

const Menu = () => {
  const location = useLocation();

  const { handleToggleMenu, open } = useMenu();

  const { userType, role, handleLogout } = useAuth();
  const navigate = useNavigate();

  const handleGoToHome = () => {
    navigate("/");
  };

  const isActive = useCallback(
    (itemHref) => {
      const isNotHome = location.pathname !== PATH_HOME;

      if (isNotHome && itemHref === PATH_HOME) {
        return false;
      }

      return location.pathname.includes(itemHref);
    },
    [location]
  );

  const isOnlyEmployee = role === "employee" && userType === "employee";

  return (
    <div
      className={`bg-gray-900 h-screen border-r border-primary fixed top-0 left-0 flex flex-col transition-width duration-300 ${
        open ? "w-[25rem]" : "w-[9.5rem]"
      }`}
    >
      <div className="p-12 flex items-center w-full justify-between">
        <img
          src="/images/logo-blank.svg"
          alt="Logo"
          onClick={handleGoToHome}
          className={`h-[3.5rem] transition-opacity duration-300 opacity-100 hover:opacity-70 cursor-pointer ${
            !open && "hidden"
          }`}
        />
        <div
          onClick={handleToggleMenu}
          className={`flex items-center justify-center cursor-pointer text-white text-2xl ${
            !open && "mx-auto"
          }`}
        >
          {open ? <FaChevronLeft /> : <FaChevronRight />}
        </div>
      </div>

      <nav className="px-8 flex flex-col gap-2">
        {menu
        .filter(item => !(hiddenForEmployee.includes(item.id) && isOnlyEmployee))
        .map((item) => (
          <Link key={`menu-${item.id}`} to={item.href} className="no-underline">
            <div
              className={`cursor-pointer flex items-center text-[1.4rem] font-semibold gap-2 py-5 px-6 rounded-[1.5rem] transition-opacity duration-300 hover:opacity-70 active:opacity-30 ${
                isActive(item.href)
                  ? "bg-white text-dark"
                  : "text-gray-400"
              }`}
            >
              <span
                className={`p-1.5 mr-3 rounded-[0.5rem] flex items-center justify-center w-[2.4rem] h-[2.4rem] ${
                  isActive(item.href)
                    ? "bg-primary text-white"
                    : "bg-white text-primary"
                }`}
              >
                {item.icon}
              </span>
              <span
                className={`transition-all duration-300 ${
                  !open && "invisible opacity-0"
                }`}
              >
                {item.title}
              </span>
            </div>
          </Link>
        ))}
      </nav>

      <div className="mt-auto mb-6 px-8">
        <div
          onClick={handleLogout}
          className="cursor-pointer flex items-center text-[1.4rem] text-gray-400 font-semibold gap-2 py-5 px-6 rounded-[1.5rem] transition-opacity duration-300 hover:opacity-70 active:opacity-30"
        >
          <span className="bg-white mr-3 p-1.5 rounded-[0.5rem] flex items-center justify-center w-[2.4rem] h-[2.4rem] text-primary">
            <FaSignOutAlt />
          </span>
          <span
            className={`transition-all duration-300 ${
              !open && "invisible opacity-0"
            }`}
          >
            Sair
          </span>
        </div>
      </div>
    </div>
  );
};

export default Menu;
